import React from 'react';
import cls from 'classnames';

import IconFont from '@/components/IconFont';
import { format2Decimal } from '@/utils/number';

import PriceInput from './CommonPriceInput';

import styles from './index.module.scss';

const Index = (props) => {
  const {
    value,
    couponValue,
    onChange,
    showCouponSelector,
    withCoupon = true,
    couponDisabled = true,
    inputDisabled = false,
    prefix,
  } = props;

  // 优惠券点击
  const handleCouponClick = () => {
    if (!couponDisabled) {
      showCouponSelector();
    }
  };

  // 渲染优惠券节点
  const renderCouponNode = () => {
    if (withCoupon) {
      const showCouponValue = couponValue && couponValue !== 0;
      return (
        <div className={cls(styles.couponWrapper, couponDisabled ? styles.couponDisabled : null)}>
          {showCouponValue ? (
            <span className={styles.couponValue} onClick={handleCouponClick}>
              {format2Decimal(couponValue)}
            </span>
          ) : (
            <span className={styles.couponSymbol} onClick={handleCouponClick}>
              <IconFont type="icon-mendianzengquantongji" />
            </span>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <PriceInput value={value} onChange={onChange} disabled={inputDisabled} prefix={prefix}>
      <div className={styles.couponContent}>{renderCouponNode()}</div>
    </PriceInput>
  );
};
export default Index;
